import { render, staticRenderFns } from "./CustomerModules.vue?vue&type=template&id=435132dc&scoped=true"
import script from "./CustomerModules.vue?vue&type=script&lang=js"
export * from "./CustomerModules.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CustomerModules.vue?vue&type=style&index=1&id=435132dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435132dc",
  null
  
)

export default component.exports